import React from 'react';
import { SEO } from '../components/SEO';
import { Link } from 'react-router-dom';
import SectionHeader from '../components/SectionHeader';

export const Clients = () => {
  const clients = [
    'Lupin', '3M', 'L\'Oreal', 'ACG', 'Baramati Agro', 'Schreiber Dynamix',
    'Atmasantulan - Santulan Ayurveda', 'Veko Care', 'Bilcare', 'Unichem',
    'Melzer', 'Honour Labs', 'Hikal Ltd', 'Genpep',
  ];

  const testimonials = [
    {
      quote: 'Working with Pegasus Clinicare has been a game-changer for our regulatory function. Their deep CDSCO expertise and proactive approach helped us achieve market approval in a timeline we hadn\'t thought possible.',
      author: 'Regulatory Affairs Head',
      company: 'Leading Indian Pharmaceutical Company',
    },
    {
      quote: 'The Pegasus team\'s GMP advisory services were thorough, practical, and result-oriented. Our manufacturing site passed a stringent audit without a single critical observation. Exceptional work.',
      author: 'Quality Assurance Director',
      company: 'Mid-Sized Pharmaceutical Manufacturer',
    },
    {
      quote: 'For our BA/BE study, we needed RLDs sourced from the US market on a very tight timeline. Pegasus delivered with full documentation within days. Highly professional and reliable.',
      author: 'Clinical Research Manager',
      company: 'Contract Research Organization',
    },
    {
      quote: 'Pegasus guided us through the entire CDSCO import approval process for our medical device range. Their documentation quality and responsiveness were excellent throughout.',
      author: 'Managing Director',
      company: 'Medical Device Importer',
    },
  ];

  return (
    <div className="pt-[72px]">
      <SEO page="clients" />
      {/* Hero */}
      <section
        className="relative py-24"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_pharma-compliance-7/artifacts/axi8n6w5_06%20Clients%20who%20Trust%20pegasus%20.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, #1570EF 0%, #1570EFee 35%, #1570EFaa 55%, transparent 75%)' }} />
        <div className="relative z-10 max-w-[1280px] mx-auto px-4 sm:px-6">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-white max-w-2xl" >Clients Who Trust Pegasus</h1>
          <p className="text-xl max-w-2xl text-white/90" >
            50+ Organizations. 7+ Industry Sectors. 10+ Years of Trusted Partnerships.
          </p>
        </div>
      </section>

      {/* Client Logos */}
      <section className="py-24 bg-white" data-testid="client-logos-section">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6">
          <SectionHeader
            label="OUR CLIENTS"
            title="Trusted by Industry Leaders"
          />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {clients.map((client, index) => (
              <div
                key={index}
                data-testid={`client-logo-${index}`}
                className="bg-white p-6 rounded-2xl border border-[#BFDBFE] hover:border-[#1570EF] hover:shadow-lg transition-all duration-300 flex items-center justify-center"
              >
                <div className="text-lg font-semibold text-center" style={{ color: '#1B3A6B' }}>
                  {client}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-24" style={{ backgroundColor: '#EFF6FF' }} data-testid="testimonials-detailed-section">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6">
          <SectionHeader
            label="TESTIMONIALS"
            title="What Our Clients Say"
          />
          <div className="grid md:grid-cols-2 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                data-testid={`testimonial-detailed-${index}`}
                className="bg-white p-8 rounded-2xl border border-[#BFDBFE] hover:border-[#1570EF] hover:shadow-xl transition-all duration-300"
              >
                <p className="text-base mb-6 italic" style={{ color: '#1E293B' }}>
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-[#BFDBFE] pt-4">
                  <div className="font-semibold" style={{ color: '#1B3A6B' }}>
                    {testimonial.author}
                  </div>
                  <div className="text-sm" style={{ color: '#0E7C86' }}>
                    {testimonial.company}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1B3A6B] text-white">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6">
            Become a Pegasus Client
          </h2>
          <Link
            to="/contact"
            data-testid="clients-cta"
            className="inline-block px-8 py-4 bg-[#1570EF] text-white font-semibold rounded-full hover:bg-[#1E40AF] hover:scale-105 transition-all duration-200"
          >
            Contact Us Today
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Clients;
